export const starLevelMap = {
  '1': '很糟',
  '2': '较差',
  '3': '一般',
  '4': '还行',
  '5': '超赞'
}

export const efficacyEvaluationMap = {
  '1': '症状加重',
  '2': '无改善',
  '3': '有点改善',
  '4': '有明显改善',
  '5': '已痊愈'
}

export const recommendationIndexMap = {
  '1': '不推荐',
  '2': '稍微推荐',
  '3': '值得一试',
  '4': '非常推荐',
  '5': '强烈推荐'
}
